export default {
  close: "Close",
  cancel: "Cancel",
  update: "Update",
  upload_image: "Upload Image",
  crop_image: "Crop Image",
  back: "Back",
  warning: "Warning",
  logout: "",
  total:"Total",
  Revenue:"Revenue",
  issue: "Issue",
  recipient: "Recipient",
  issues: "Issues",
  general: "General",
  your_name: "Your Name",
  email: "Email",
  phone: "Phone",
  empty: "There are no data.",
  unknown: "Unknown",
  Nothinghere:"Nothing here.",
  all: "All",
  mobile_operator: "Mobile Operator",
  age: "Age",
  browser: "Browsers",
  catalog: "Catalog",
  other: "Other",
  settings: "Settings",
  mass_mail: "Mass Mail",
  background: "Background",
  manager: "Manager",
  analytic: "Analytics",
  input: "Input",
  promotion: "Promotion",
  magazine: "Magazine",
  subscription: "Subscription",
  ip: "IP Address",
  adscontent: "ADS",
  choose: "Choose",
  wifi: "WIFI",
  banners: "Banner",
  logo: "Logo",
  name: "Name",
  userName: "User Name",
  organization: "Organization",
  person: "Person",
  reset: "Reset",
  pages: "Pages",
  detail: "Details",
  changeLanguage: "Change Language",
  change: "Change",
  revoke: "Revoke",
  edit: "Edit",
  tools: "Tools",
  cacheClear: "Clear Cache",
  clear: "Clear",
  view: "View",
  select: "Select",
  conSocialAcc: "Connected Social Accounts",
  undisIncome: "Undistributed Income",
  completeAccess: "Complementary Access",
  ads: {
    ads: "Advertisement",
    adsview: "ADS View"
  },
  subscriptions: {
    orders: "Orders",
    subscriptions: "Subscriptions",
    activations: "Activations",
    plan: "Subscription Plan",

  },

  account: {
    add: "Add Account",
  },

  auth: {
    logout: "Logout",
    confirm: "Are you sure to logout?"
  },

  dropdown: {
    filters: "Filters",
    salesFilter: "Sales Filter",
    stateFilter: "Filter with State",
    category: "Category",
    language: "Language",
    country: "Country"
  },

  magazines: {
    magazines: "Magazines",
    issues: "Issue",
    categories: "Categories",
    feeds: "Feeds",
    add: "Add Magazine",
    income: "Magazine Income",
    revenue: "Revenue Report",
  },

  verification: {
    _name: "Account Verification",
    verified: "Verified",
    unverified: "Unverified",
    verify_account: "Verify Account",
    mail_sent:
      "Verification email has sent to your `{email}` email. Please check your inbox.",
    resend: "Resend",
    check_email:
      "Please check your email address then click the `Verify Account` button.",
    done: "Congratulations, Your account has successfully verified."
  },

  profile: {
    title: "Profile",
    my_title: "My Profile",
    settings_desc:
      "Manage information about you, including your name in app, the email address you get notified at, and your authentication information",
    update_avatar: "Update avatar",
    avatar_updated: "Your avatar has been updated.",
    edit_name: "Edit Name",
    edit_phone: "Edit Phone",
    edit_password: "Set new password",
    updated: "Your profile information has been updated."
  },

  password: {
    _name: "Password",
    new: "New password",
    confirm: "Confirm password",
    hint: "At least 6 characters."
  },

  admin_panel: {
    title: "Admin panel",
    desc:
      "You are a member of the {app} developers. You can go to the admin panel by clicking the button."
  },

  publisher_panel: {
    desc:
      "You are owning a {app} publisher rights. You can go to the admin panel by clicking the button."
  },

  library: {
    title: "Library",
    empty: "Your library has no items."
  },

  publication: {
    _name: "Publication | Publications",
    published: "Published Publication | Published Publications",
    type: {
      magazine: "Magazine",
      book: "Book",
      audio_book: "Audio Book",
      podcast: "Podcast"
    },
    interests: "Publication Interests",
    opens: "Publication Opens"
  },

  devices: {
    title: "Devices",
    empty: "You have no devices registered."
  },

  device: {
    _name: "Device | Devices",
    manufacturer: "Manufacturer",
    model: "Model",
    registered_on: "Registered Date",
    last_used_date: "Last Used",
    version: "Device version | Device versions",
    OS: "Operating System",
    Socials: "Social",
    usage: "Usage",
  },

  purchases: {
    title: "Purchases",
    empty: "There is no purchase done yet."
  },

  price: {
    with_curr: "Price ({curr})"
  },

  support_tickets: {
    title: "Support Tickets"
  },

  support_ticket: {
    _name: "Support Ticket",
    new: "New Ticket",
    title: "Title",
    desc: "Description",
    file: "File",
    auto: "Automate",
    status: {
      _name: "Status",
      open: "Open",
      closed: "Closed",
      published: "Published",
      unpublished: "Unpublished",
      draft: "Draft",
      check: "Checking"
    },
    user_type: {
      customer: "Customer",
      officer: "Officer"
    },
    send: "Send ticket",
    sent: "Your message has been sent.",
    reply: "Reply",
    last_reply: "Last Reply",
    send_reply: "Send reply",
    compose_reply: "Compose Reply"
  },

  user: {
    _name: "User | Users",
    new: "New User | New Users",
    all: "All",
    active: "Active",
    preregistered: "Preregistered",
    bycountry: "Devices by Country",
    currentActiveUser: "Current Active Users",
    inactiveUser: "Inactive Users",
    newUser: "New Users",
    purchasedUser: "Purchased Users",
    role: "Role",
  },


  publisher: {
    _name: "Publisher | Publishers",
    approvals: "Publisher approvals",
    register: "Publisher registration",
    add: "Add Publisher"
  },

  author: {
    _name: "Author | Authors"
  },

  promotions: {
    promo: "Promotion",
    campaign: "Campaign"
  },

  download: {
    verb: "Download",
    _name: "Downloads",
    total: "Total downloads",
    view: "View",
    report: {
      title: "Download Report",
      vReport: "Views Report"
    },
  },
    lyticView: {
      title: "Analytic / General",
      read: "Page Views",
    },

    dashboard: {
      app: {
        title: "Dashboard"
      },

      web: {
        title: "Web Traffic",
        guests_and_views: "Guests and page views",
        most_visited_pages: "Most visited pages",
        external_links: "External links",
        external_links_desc: "Web pages that are referring to our app."
      }
    },
    review: {
      title: "Review",
    },
    analytics: {
      title: "Analytic",
      aissue: "Analytic / Issue",
      auser: "User",
      purchase_data: "Order / Report"
    },

    dater: {
      l15: "Last 15 Days",
      today: "Today",
      yesterday: "Yesterday",
      thisweek: "This Week",
      lastweek: "Last Week",
      thismonth: "This Month",
      lastmonth: "Last Month",
      thisyear: "This Year",
      lastyear: "Last Year",
      custom: "Custom",
      range: "Range",
      latest: "Latest at",
      updated: "Updated at",
      created: "Created at",
      start: "Start at",
      end: "End at",
      registered: "Registered at",
      date: "Date",
      published: "Published date",
    },

    selling: {
      _name: "Selling",
      sales: "Sales",
      revenue: "Revenue"
    },
    userDevice: {
      title: "New user and Devices"
    },
    downloadOpen: {
      title: "Download and Views",
      opens: "Views",
      downloads: "Downloads"
    },
    date: {
      _name: "Date",
      range: "Date Range",
      period: {
        today: "Today",
        this_week: "This week"
      }
    },

    app_open: {
      _name: "App Open | App Opens"
    },
    feedback: {
      title: "Feedback",
    },
    frequency: {
      first_time: "First Time",
      again: "Again"
    },

    gender: {
      _name: "Gender",
      male: "Male",
      female: "Female"
    },

    comment: {
      _name: "Comment | Comments"
    },

    series: {
      _name: "Series"
    },

    like: {
      _name: "Like | Likes"
    },

    search: {
      _name: "Search",
      user: "Search User",
      publisher: "Search by Publisher",
      publisherMag: "Search Publsiher and Magazine",
      magazine: "Search Magazine",
      issue: "Search Issue",
      search: "Search",
      device: "Search Device",
      comments: "Search Comments",
      last: "Last Search",
      mostKeyword: "Most used Keyword",
      useKeyword: "Keyword",
      usedCount: "Used Count",
      result: "Result",
    },
    pay: {
      all: "All",
      paid: "Paid",
      unpaid: "Unpaid",
      cancel: "Cancel",
      test: "Test",
      balance: "Balance"
    },
    generate: {
      report: "Report",
    },
    most: {
      read: "Most read Magazine",
      issue: "Most engaged Issue",
      page: "Most engaged page",
      article: "Most read free Article",
      view: "Most viewed issue",
      download: "Most downloaded issue"
    },
    add: {
      issue: "Add Issue",
      collection: "Add Collections",
      access: "Add Access",
      adsPage: "Add ADS Page",
      addWifi: "Add Wifi",
      user: "Add User",
      banner: "Add Banner",
      manager: "Add Manager"
    },
    os: {
      _name: "Operating system",
      version: "OS version | OS versions"
    },

    guests: {
      total: "Total guests",
      new: "New Guests",
      returning: "Returning Guests"
    },

    collection: {
      _name: "Collection | Collections"
    },

    invoice: {
      _name: "Invoice | Invoices"
    },

    income: {
      undistributed: "Undistributed Income | Undistributed Incomes",
      distribution: {
        _name: "Distribution | Distributions"
      }
    },

    marketing: {
      _name: "Marketing"
    },

    slider: {
      _name: "Sliders"
    },

    banner: {
      _name: "Banners"
    },

    lottery: {
      _name: "Lotteries"
    },

    blog: {
      _name: "Blog"
    },

    unlock: {
      _name: "Authorization | Authorizations"
    },

    logs: {
      _name: "Logs"
    },

    activity_log: {
      _name: "Activity  "
    },

    notification: {
      _name: "Notification | Notifications",
      send: "Send Notification",
      scheduled: "Scheduled Notification",
    },

    register: {
      create_account: "Create Account",
    }
};
